export const CommissionsType = {
  setCommissions: "[Commissions] setCommissions",
  error: "[Commissions] Error",
};
